import syles from "./homepage.module.scss"
export const Home = ()=>{
    return <div className={syles.container}>
        <h1 className="">under contruction</h1>
    </div>
}